export enum ContentMode {
  FORECAST_ONLY = 'forecastOnly',
  FORECAST_AND_HISTORY = 'forecastAndHistory',
  SELECTED_TIMERANGE = 'selectedTimeRange',
}
